export class LastSearchesEntryDTO {
  route!: string;
  query!: string;

  constructor(params: Partial<LastSearchesEntryDTO>) {
    Object.assign(this, {
      route: params.route ?? "",
      query: params.query ?? "",
    });
  }
}
